<template>
  <section>
    <div class="operated">
      <img src="~@/assets/images/wheelchair.svg" alt="Paciente Recém Operado" />
      <div class="operated-info">
        <p><strong>Alguma intercorrência?</strong></p>
        <p>Se precisar falar com um médico, ligue para a nossa equipe:</p>

        <b-button @click="redirectToChat()" class="btn-orange">
          Acessar chat
        </b-button>
      </div>
    </div>
    <FastCards />
  </section>
</template>

<script>
import FastCards from '../fastcards/FastCards'

export default {
  name: 'RecentlyOperated',
  components: { FastCards },
  methods: {
    redirectToChat() {
      window.location.href = 'http://www.sarah.br/chat'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';

.operated {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 3.75rem;

  .operated-info h1 {
    margin-top: 2rem;
    font-weight: $font-bold;

    font-size: 1.625rem;
  }
}
</style>
